// 模拟秒级数据生成（101条，含初始数据）

import axios from 'axios'
import contractaa from '../contract/index.js'

 let data = [
    []
];
// await axios.get(contractaa.APIURL+'?cmd=getexchangedata').then(function (response) {
// if (response.status === 200) {
//         //console.log("axios_data:"+response.data.Data)
//         data = response.data.Data
//     }
// })
export {
    data
}